'use client';

import { useHero } from './HeroContext';
import { useRef, useEffect } from 'react';

const MOBILE_MQ = '(max-width: 719px)';

/**
 * @param {{ video: string, videoMobile?: string }} props
 */
export default function HeroVideo({ video, videoMobile }) {
  const { video: contextVideo } = useHero();
  const activeVideo = contextVideo || video;
  const heroMediaRef = /** @type {{ current: HTMLDivElement | null }} */ (useRef(null));
  const videoRef = /** @type {{ current: HTMLVideoElement | null }} */ (useRef(null));

  useEffect(() => {
    /** @type {number} */
    let frameId;
    const handleScroll = () => {
      frameId = requestAnimationFrame(() => {
        if (heroMediaRef.current) {
          heroMediaRef.current.style.transform = `translateY(${window.scrollY * 0.5}px)`;
        }
      });
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => {
      window.removeEventListener('scroll', handleScroll);
      cancelAnimationFrame(frameId);
    };
  }, []);

  useEffect(() => {
    if (!videoRef.current) return;

    const mq = window.matchMedia(MOBILE_MQ);

    const update = () => {
      if (!videoRef.current) return;
      const src = videoMobile && mq.matches ? videoMobile : activeVideo;
      videoRef.current.src = src;
      videoRef.current.load();
    };

    update();

    if (videoMobile) {
      mq.addEventListener('change', update);
      return () => mq.removeEventListener('change', update);
    }
  }, [activeVideo, videoMobile]);

  if (!activeVideo) {
    return <div className="Hero__video Hero__video--empty"></div>;
  }

  return (
    <div className="Hero__video" ref={heroMediaRef}>
      <video autoPlay muted loop playsInline preload="auto" ref={videoRef} />
    </div>
  );
}
